export const endpoint = "https://qbmedia.b-cdn.net/qbmedia/"